import axios from "axios";
import Swal from "sweetalert2";
import colors from "../config/Colors.config";
import Request from "../interfaces/Request.interface"
import Response from "../interfaces/Response.interface";

const executeRequest = async (request: Request): Promise<Response> => {
    
    let response: any;
    let data: Response;
    try {
        data = await axios({
            url: request.url,
            method: request.method,
            headers: request.headers,
            data: request.data
        });
        if (data.data.error === true) messageError(data.data.message)
        response = {
            error: false, //data.data.error,
            message: data.data.message,
            data: data.data
        };
    } catch (error) {
        messageError(error);
        response = {
            error: true,
            data: error,
            message: "ERROR"
        };
    }
    return response;

}

const executeRequestEspacial = async (request: Request): Promise<Response> => {
    
    let response: any;
    let data: Response;
    try {
        data = await axios({
            url: request.url,
            method: request.method,
            headers: request.headers,
            data: request.data
        });
        // if (data.data.error === true) messageError(data.data.message)
        response = {
            error: false, //data.data.error,
            message: data.data.message,
            data: data.data
        };
    } catch (error) {
        // messageError(error);
        response = {
            error: true,
            data: error,
            message: "ERROR"
        };
    }
    return response;

}

const messageError = (error: any): void => {
    Swal.fire({
        icon: "error",
        title: "Error en la petición",
        text: error.message,
        showConfirmButton: true,
        confirmButtonColor: colors.cafe,
        timerProgressBar: true,
        footer: JSON.stringify(error)
    });
}

const ApiConfig = {
    executeRequest,
    executeRequestEspacial
}

export default ApiConfig;